<script>
import axios from 'axios'

export default {
    data() {
        return {
            show: false,
            error: null,
            authError: null,
            loading: true,
            regModel: {
                email: null,
                password: null,
                plan: 1,
                tariff: -1,
                domain: this.getUrlParam('domain')

            },
            word: this.$t('lang.main.numbers_2'),
            locale: window.locale
        }
    },
    props: {
        isAuthorized: {
            type: Boolean,
            required: true
        },
        isPayed: {
            type: Boolean,
            required: false,
            default: false
        },
        returnUrl: {
            type: String,
            required: false,
            default: ""
        },
        tariffPercent: {
            type: Array,
        },
        tariffTemplates: {
            type: Object
        }
    },
    methods: {

        showStub(){

            let element = document.getElementsByTagName('body')[0];
            element.classList.add("modal-open");

            this.show = true;

        },
        onRegSubmit(){

            this.error = null;
            this.loading = true;
            let self = this;

            let data = this.regModel;

            axios({
                method: 'post',
                url: this.getRegApi,
                withCredentials: true,
                data: data
            })
                .then(function () {
                    self.loading = false;
                    window.location.href = "/" + window.locale + "/successful-registration";
                }).catch(function (error) {
                self.loading = false;
                self.error = error.response.data.message;
            });


        },

        getUrlParam(parameter, defaultvalue = null){
            let url = new URL(window.location.href);
            let param = url.searchParams.get(parameter);

            return param ? param : defaultvalue;

        },

        changePlan(plan){
            if(plan === 1){
                this.regModel.domain = this.regModel.domain.replace(/\r\n/g,"\n").split("\n")[0];
            }

            this.regModel.plan = plan;
        },

    },

    computed: {
        getRegApi(){
            return this.$config.API_URL + "/panel/user/register";
        },
        getTitleUserRegisterAuth() {
            return this.$t('lang.promo_tariff.limit_no_auth');
        }
    },

    mounted() {
        setTimeout(() => this.showStub(), 1000);
    },

}
</script>

<template>
    <transition name="modal">
        <div class="popup-container" v-if="show">
            <div class="popup-overlay"></div>
            <div class="limit-container" v-if="isAuthorized">

                <div class="limit-header">
                    <p>{{$t('lang.promo_tariff.header')}}&nbsp;&nbsp;&nbsp;
                        <a :href="'/' + locale + '/tarif'" class="greenbutton text-center">{{$t('lang.promo_tariff.choose_plan')}}</a></p>
                </div>
                <div class="content" style="width: 555px; padding: 40px; margin: auto;">

                    <div class="content-inner">
                        <div class="title"><span>keys.so</span></div>
                        <form @submit.prevent="onRegSubmit">
                            <div class="ks-alert alert alert-danger" v-text="error" v-if="error"></div>

                            <h3>{{$t('lang.promo_tariff.limit')}}</h3>

                            <div class="clearfix h5"></div>

                        </form>

                    </div>

                </div>

            </div>
        </div>

    </transition>
</template>
<style scoped>
.popup-container {
    font-size: 14px;
    line-height: 14px;
    color: #333;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    z-index: 100009;
}

.popup-overlay {
    background: #000;
    opacity: .8;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 100005;
}

.limit-container{
    width: 1024px;
    overflow: hidden;
    position: relative;
    z-index: 100008;
    margin: 0 auto;
}

.limit-header{
    margin: 80px 0 0;
    height: 80px;
    color: #fff;
    width: 100%;
    text-align: center;
}
.limit-header p {padding-top: 45px; color: #fff;}
.limit-header .greenbutton {padding: 5px 5px;}

.footer-auth-form h3{
    display: inline;
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
}

.footer-auth-form p{
    display: inline; color: #fff;
}

.contact-form-description a{
    color: #ccc;
}

.content {
    display: flex;
    justify-content: center;
}

.content h3{
    font-size: 18px;
    line-height: normal;
    font-weight: 300;
    text-align: justify;
}

.content-header p {
    color: #fff;
}

.content-inner{
    padding: 40px;
    background: #FFFFFF;
}

.title{
    margin: 0 0 24px;
    line-height: 20px;
    color: #333;
    text-align: center;
    padding: 0;
}

.title span{
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
}

form input, form textarea {display: block; font-weight: 300; font-size: 14px; border: solid 1px #d0d3d8; padding: 10px 20px; width: 100%;}
form input[type="submit"] {background: #68aa13; border: none; border-radius: 4px; color: #fff; text-transform: uppercase; font-size: 12px; font-weight: bold; cursor: pointer; padding: 10px 20px; display: inline-block; width: auto; margin-right: 10px;}
form input[type="submit"]:hover {background: #15aac0; text-shadow: 0 0 8px rgba(255,255,255,1);}

.footer-auth-form-wrapper form input{width: auto; border-radius: 5px;}
.footer-auth-form-wrapper form input[type="submit"] {padding: 12px 20px}
.footer-auth-form-wrapper form .inpcont{
    position: relative;
    display: inline-block;
    width: auto;
    vertical-align: top;

}

form label {
    display: block;
    font-weight: 500;
    font-size: 12px;
    margin: 10px 0 0 0;
}

form textarea {
    height: 70px;
}

.ks-alert{
    padding: 5px!important; font-size: 12px!important;
}

</style>
